"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _actions = require("./actions");

var _PortalSettingsKeys = _interopRequireDefault(require("settings-ui-sdk/constants/PortalSettingsKeys"));

var _AppActions = require("../actions/AppActions");

var _handleActions;

var initialState = (0, _immutable.fromJS)({
  data: (0, _immutable.Map)(),
  staged: (0, _immutable.Map)()
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchPortalSettingsActionTypes.SUCCESS, function (state, action) {
  var settings = (0, _immutable.Map)(action.payload.data.settings.reduce(function (acc, current) {
    return Object.assign({}, acc, (0, _defineProperty2.default)({}, current.key, current.value));
  }, {}));
  return state.merge({
    data: settings,
    staged: settings,
    response: action.payload.data.settings
  });
}), (0, _defineProperty2.default)(_handleActions, _actions.SavePortalSettingActionTypes.SUCCESS, function (state, action) {
  var _action$payload$data = action.payload.data,
      key = _action$payload$data.key,
      value = _action$payload$data.value;
  var keyIndex = state.get('response').findIndex(function (sub) {
    return sub.get('key') === _PortalSettingsKeys.default.GDPR_COMPLIANCE_ENABLED;
  });
  return state.setIn(['data', key], value).setIn(['response', keyIndex, 'value'], value);
}), (0, _defineProperty2.default)(_handleActions, _actions.StageAndSavePortalSettingActionTypes.SUCCESS, function (state, action) {
  return state.setIn(['staged', action.payload.data.key], action.payload.data.value).setIn(['data', action.payload.data.key], action.payload.data.value);
}), (0, _defineProperty2.default)(_handleActions, _AppActions.AppActionTypes.RESET_STAGED_CHANGES, function (state) {
  return state.set('staged', state.get('data'));
}), (0, _defineProperty2.default)(_handleActions, _actions.PortalSettingsActionTypes.STAGE_PORTAL_SETTING, function (state, action) {
  return state.setIn(['staged', action.payload.key], action.payload.value);
}), (0, _defineProperty2.default)(_handleActions, _actions.PortalSettingsActionTypes.UNSTAGE_PORTAL_SETTING, function (state, action) {
  return state.setIn(['staged', action.payload.key], state.getIn(['data', action.payload.key]));
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;